import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { projects } from '../data/mock';

const Projects = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  const toggleProject = (projectId) => {
    setExpandedProject(expandedProject === projectId ? null : projectId);
  };

  return (
    <section
      id="projects"
      className="py-20 md:py-24 px-6 border-b border-stone-400/25 dark:border-stone-500/20 bg-white/[0.22] dark:bg-stone-950/30"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <h2 className="text-4xl font-bold text-stone-900 dark:text-stone-100 mb-4 leading-tight">
            Projects
          </h2>
          <div className="w-16 h-1 bg-amber-800 dark:bg-amber-600 rounded-full mb-4" />
          <p className="text-base text-stone-600 dark:text-stone-400 max-w-2xl">
            Quality and Automation from first integrations through every release.
          </p>
        </div>

        <div className="space-y-16">
          {projects.map((project, index) => (
            <div key={project.id} className="group">
              <div className="grid md:grid-cols-12 gap-8">
                <div className="md:col-span-4">
                  <div className="md:sticky md:top-28 space-y-3">
                    <div className="text-xs text-stone-500 dark:text-stone-400 uppercase tracking-wider font-medium">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    <h3 className="text-2xl md:text-3xl font-bold text-stone-900 dark:text-stone-100 leading-tight">
                      {project.title}
                    </h3>
                    <p className="text-sm text-amber-800 dark:text-amber-500 font-medium">{project.role}</p>
                    <div className="flex flex-wrap gap-2">
                      {project.categories.map((category, idx) => (
                        <span
                          key={idx}
                          className="px-2.5 py-1 bg-amber-100 dark:bg-amber-900/30 text-amber-900 dark:text-amber-200 rounded-full text-xs font-medium"
                        >
                          {category}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="md:col-span-8 space-y-6">
                  <p className="text-base text-stone-600 dark:text-stone-300 leading-relaxed">
                    {project.description}
                  </p>

                  <div>
                    <h4 className="text-xs font-bold text-stone-900 dark:text-stone-100 uppercase tracking-wider mb-3">
                      Highlights
                    </h4>
                    <ul className="space-y-2">
                      {project.impact.map((item, idx) => (
                        <li key={idx} className="flex items-start gap-3 text-sm text-stone-600 dark:text-stone-300">
                          <span className="w-1.5 h-1.5 bg-amber-700 dark:bg-amber-500 rounded-full mt-2 shrink-0" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    <button
                      type="button"
                      onClick={() => toggleProject(project.id)}
                      className="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-600 hover:text-amber-900 dark:hover:text-amber-500 font-medium transition-colors"
                    >
                      <span>{expandedProject === project.id ? 'Hide' : 'View'} tech stack</span>
                      {expandedProject === project.id ? (
                        <ChevronUp className="w-4 h-4" />
                      ) : (
                        <ChevronDown className="w-4 h-4" />
                      )}
                    </button>
                    {expandedProject === project.id && (
                      <div className="mt-4 flex flex-wrap gap-2">
                        {project.techStack.map((tech, idx) => (
                          <span
                            key={idx}
                            className="px-3 py-1.5 bg-stone-100 dark:bg-stone-700 text-stone-700 dark:text-stone-300 rounded-full text-xs font-medium"
                          >
                            {tech}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {index < projects.length - 1 && (
                <div className="mt-16 h-px bg-stone-200/80 dark:bg-stone-700/80" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
